function getAcceptableData<T>(
  data: T | null | undefined,
  shouldCache?: (data: T) => boolean
): T | null {
  if (data == null) return null
  if (shouldCache && !shouldCache(data)) return null
  return data
}

export { getAcceptableData }
